import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export function NotesLoading() {
  return (
    <Grid item xs={12}>
      <Typography align="center">Fetching notes...</Typography>
      <Box display="flex" justifyContent="center" mt={2} mb={2}>
        <CircularProgress size={80} />
      </Box>
    </Grid>
  );
}
